// extracted by mini-css-extract-plugin
export default {"member":"memberAssigned_member__Zhm1I","total":"memberAssigned_total__CvSNq"};